import { Form } from './form'

class ResetForm extends Form {
  constructor(el) {
    super(el)
    this.resetContainer = el
  }
}

const resetFormInit = {
  // eslint-disable-next-line consistent-return
  init() {
    const wrapperEl = document.querySelectorAll('.form--reset')
    Array.from(wrapperEl).forEach(form => new ResetForm(form))
  },
}

export default resetFormInit
